import React from 'react';

import { faInstagram } from '@fortawesome/free-brands-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Trans } from '@lingui/macro';
import Grid from '@mui/material/Grid';
import TextField from '@mui/material/TextField';

import FormInlineButton from '../../../misc/FormInlineButton';

const id = 'instagram';
const name = 'Instagram';
const version = '1.2';
const stream_key_link = 'https://about.instagram.com/blog/tips-and-tricks/instagram-live-producer';
const description = (
	<Trans>
		Live-Streaming to Instagram Live RTMP Service.
	</Trans>
);
const image_copyright = '';
const author = {
	creator: {
		name: 'SocialCast',
		link: 'https://aj-itelectronics.com',
	},
	maintainer: {
		name: 'SocialCast',
		link: 'https://aj-itelectronics.com',
	},
};
const category = 'platform';
const requires = {
	protocols: ['rtmps'],
	formats: ['flv'],
	codecs: {
		audio: ['none'],
		video: ['none'],
	},
};

function ServiceIcon(props) {
	return <FontAwesomeIcon icon={faInstagram} style={{ color: '#E1306C' }} {...props} />;
}

function init(settings) {
	const initSettings = {
		key: '',
		...settings,
	};

	return initSettings;

}

function Service(props) {
	const settings = init(props.settings);

	const handleChange = (what) => (event) => {
		const value = event.target.value;

		settings[what] = value;

		const output = createOutput(settings);

		props.onChange([output], settings);
	};

	const createOutput = (settings) => {
		const output = {
			address: 'rtmps://edgetee-upload-atl3-1.xx.fbcdn.net:443/rtmp/' + settings.key,
			options: [
				'-stream_loop', '-1', '-i', settings.background, '-filter_complex',
				'[0]scale=' + settings.width + ':' + settings.height + '[inner];[1][inner]overlay=' + settings.x + ':' + settings.y + ':shortest=1[vid]',
				'-map',
				'[vid]',
				'-map',
				'0:a',
				'-g',
				'30',
				'-r',
				'29.97',
				'-crf',
				'23',
				'-s',
				'720x1280',
				'-aspect',
				'9:16',
				'-c:a',
				'aac',
				'-strict',
				'strict',
				'-ar',
				'44100',
				'-ac',
				'2',
				'-b:a',
				'256k',
				'-pix_fmt',
				'yuv420p',
				'-c:v',
				'libx264',
				'-f',
				'flv'
			],
		};

		return output;
	};

	return (
		<Grid container spacing={2}>
			<Grid item xs={12} md={12}>
				<TextField variant="outlined" fullWidth label={<Trans>Back cover</Trans>} value={settings.background} onChange={handleChange('background')} />
			</Grid>
			<Grid container justifyContent="center" item xs={6} md={3} >
				<TextField variant="outlined" fullWidth label={<Trans>W (Ex.: 690)</Trans>} value={settings.width} onChange={handleChange('width')} />
				<TextField variant="outlined" fullWidth label={<Trans>H (Ex.: 490)</Trans>} value={settings.height} onChange={handleChange('height')} />
			</Grid>
			<Grid item xs={6} md={3}>
				<TextField variant="outlined" fullWidth label={<Trans>X (Ex.: 17)</Trans>} value={settings.x} onChange={handleChange('x')} />
				<TextField variant="outlined" fullWidth label={<Trans>Y (Ex.: 248)</Trans>} value={settings.y} onChange={handleChange('y')} />
			</Grid>
			<Grid item xs={12} md={9}>
				<TextField variant="outlined" fullWidth label={<Trans>Stream key</Trans>} value={settings.key} onChange={handleChange('key')} />
			</Grid>
			<Grid item xs={12} md={3}>
				<FormInlineButton target="blank" href={stream_key_link} component="a">
					<Trans>GET</Trans>
				</FormInlineButton>
			</Grid>
		</Grid>
	);
}

Service.defaultProps = {
	settings: {},
	skills: {},
	metadata: {},
	streams: [],
	onChange: function (output, settings) { },
};

export { id, name, version, stream_key_link, description, image_copyright, author, category, requires, ServiceIcon as icon, Service as component };
